<template>
  <LoggedInStart v-if="!$auth.loading && $auth.isAuthenticated"/>
  <LoggedOutStart v-else/>
</template>

<script>
import LoggedInStart from '@/components/LoggedInStart'
import LoggedOutStart from '@/components/LoggedOutStart'

export default {
  name: 'Start',

  components: {
    LoggedInStart,
    LoggedOutStart
  }

}
</script>